export const SELECT_ALL_VALUE = "ALL";

export const env = {
  getAppName: () => window._env_.REACT_APP_NAME,
  getAppUrl: () => window._env_.REACT_APP_URL,
};
